import { render, staticRenderFns } from "./TechInventoryCard.vue?vue&type=template&id=2daca008"
import script from "./TechInventoryCard.vue?vue&type=script&lang=js"
export * from "./TechInventoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports